var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackReferesh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9709 22.6468C11.5514 22.6468 9.50212 21.8072 7.82295 20.1281C6.14378 18.4489 5.3042 16.3996 5.3042 13.9801C5.3042 11.5607 6.14378 9.51139 7.82295 7.83223C9.50212 6.15306 11.5514 5.31348 13.9709 5.31348C15.2167 5.31348 16.4084 5.57059 17.5459 6.08481C18.6834 6.59903 19.6584 7.33498 20.4709 8.29264V5.31348H22.6375V12.8968H15.0542V10.7301H19.6042C19.0264 9.71903 18.2367 8.92459 17.2349 8.34681C16.2332 7.76903 15.1452 7.48014 13.9709 7.48014C12.1653 7.48014 10.6306 8.11209 9.3667 9.37598C8.10281 10.6399 7.47087 12.1746 7.47087 13.9801C7.47087 15.7857 8.10281 17.3204 9.3667 18.5843C10.6306 19.8482 12.1653 20.4801 13.9709 20.4801C15.3611 20.4801 16.616 20.0829 17.7354 19.2885C18.8549 18.494 19.6403 17.4468 20.0917 16.1468H22.3667C21.8611 18.0607 20.832 19.6225 19.2792 20.8322C17.7264 22.0419 15.957 22.6468 13.9709 22.6468Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackReferesh);
export default __webpack_public_path__ + "static/media/blackReferesh.26470b4ee0ce68fa08b2032385ddde41.svg";
export { ForwardRef as ReactComponent };